<div class="bottom-nav-container" *ngIf="bottomNavData.ShowNav">
    <div class="button-alignment">
        <adp-button (clickEventCb)="cancel()" [resourceData]="cancelButtonResource" [styleClass]="'btn btn-light btn-secondary  adp-btn'" ></adp-button>
    </div>
    <div class="button-alignment">
        <adp-button  (clickEventCb)="back()"  [resourceData]="backButtonResource" [styleClass]= "'btn btn-nav-back'" ></adp-button>
        <adp-button    (clickEventCb)="continue()"  [resourceData]="continueButtonResource"  [styleClass]="'btn btn-primary adp-btn'"></adp-button>
    </div>
</div>